var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.999 138.012C282.189 146.77 273.548 152.43 264.001 152.43H183.999V480.324C183.999 493.574 173.249 504.324 159.999 504.324S135.999 493.574 135.999 480.324V152.43H55.999C46.453 152.43 37.812 146.77 33.997 138.012C30.187 129.258 31.921 119.063 38.406 112.074L142.406 0C151.906 -10.234 168.095 -10.234 177.593 0L281.595 112.074C288.08 119.063 289.814 129.258 285.999 138.012Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLong);
export default __webpack_public_path__ + "static/media/up-long.7e5624ce5a958203fa2219cd8647dc35.svg";
export { ForwardRef as ReactComponent };